export default "__VITE_ASSET__CHDv7RlK__"